export const langToCountry: Record<string, string> = {
  en: 'us',
  pt: 'br',
  es: 'es',
  it: 'it',
};
